export enum SystemRole {
    VIEWER = 0,
    EDITOR = 1,
    APPROVER = 2,
    EXTERNAL = 3
}